const baseUrl = window.location.href.includes("portal.legalpredictabill")
  ? "https://portal.legalpredictabill.com"
  : window.location.href.includes("legally.legalpredictabill")
  ? "https://legally.legalpredictabill.com"
  : window.location.href.includes("zapotal")
  ? "https://zapotal.blplegal.com"
  : window.location.href.includes("idbinvest")
  ? "https://idbinvest.blplegal.com"
  : window.location.href.includes("epa")
  ? "https://epa.blplegal.com"
  : window.location.href.includes("subway")
  ? "https://subway.legalpredictabill.com"
  : window.location.href.includes("kraft")
  ? "https://kraft.legalpredictabill.com"
  : window.location.href.includes("vololoans")
  ? "https://vololoans.blplegal.com"
  : window.location.href.includes("asal")
  ? "https://asal.blplegal.com"
  : window.location.href.includes("blplegal")
  ? "https://portal.blplegal.com"
  : window.location.href.includes("blp-clientportal-qa")
  ? "https://blp-clientportal-qa.azurewebsites.net"
  : window.location.href.includes("blp-clientportal-dev")
  ? "https://blp-clientportal-dev.azurewebsites.net"
  : window.location.href.includes("legally.legalprb")
  ? "https://legally.legalprb.com"
  : window.location.href.includes("kraft.legalprb")
  ? "https://kraft.legalprb.com"
  : window.location.href.includes("stratos.legalprb")
  ? "https://stratos.legalprb.com"
  : window.location.href.includes("subway.legalprb")
  ? "https://subway.legalprb.com"
  : "http://localhost:3000";

export const msalConfig = {
  auth: {
    clientId: "a98a110a-82cf-4f5d-9421-dcb4b0e9c761",
    authority:
      "https://login.microsoftonline.com/b6357f72-8f4e-4ba9-b28c-3ea6aaaef0af",
    redirectUri: `${baseUrl}/auth/callback`,
    postLogoutRedirectUri: `${baseUrl}/SignInAD`,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "email"],
  // Without this, MSAL defaults redirectStartPage to whatever page the user
  // clicked login from (e.g. /SignInAD) and automatically navigates back
  // there once it's done processing the response on redirectUri — yanking
  // the browser away from /auth/callback mid-flight. Pointing it at the
  // callback page itself keeps navigation entirely under our own control.
  redirectStartPage: `${baseUrl}/auth/callback`,
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com",
};
